import type { FaireProductEntity } from "../../entity_types/product";

export const starter_collection_111: FaireProductEntity = {
  token: "starter_collection_111",
  type: "product",
  name: "Rope Split Ring",
  brandName: "Craighill",
  imageUrl:
    "https://cdn.faire.com/fastly/a6385bd90d835de5c2d6560bf3175fe51c171221bdf9b93b7e96efc769f771e6.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=1440&width=1440",
  priceDollars: 18,
  msrpDollars: 36,
  description: "Migrated starter collections product",
  tags: ["starter-collections"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
